module.exports = __webpack_public_path__ + "static/media/AB_N1_24.6acea524.jpg";